<template>
  <el-dialog title="" v-model="value" size="tiny" custom-class="all-embassy-holiday-pop" :show-close="false" top="50%" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="close-box" @click="closePop()">
      <img src="https://o.666visa.cn/static/ssqpeer/homepage/icon-close-background-black.png" />
    </div>
    <div class="QR-boxcode-box">
      <img :src="qrcodeUrl"/>
      <div>微信扫码</div>
      <span>一键分享给顾客</span>
    </div>
    <div class="title-box">
      使馆假期/近两月<span>Holiday</span>
    </div>
    <div class="content-box">
      <el-select class="select-box" v-model="continentSelect" @change="continentSelectChange">
        <el-option v-for="item in continent_name" :key="item.continent_id" :label="item.name" :value="item.continent_id">
        </el-option>
      </el-select>
      <img class="select-icon" src="https://o.666visa.cn/static/ssqpeer/homepage/icon-map-blue-2x.png" />
      <div class="content" :class="{'no-background': noBackground}">
        <div class="title">
          <div class="title-continent">大洲</div>
          <div class="title-country">国家</div>
          <div class="title-time">放假时间</div>
        </div>
        <div class="continent-box">
          <div class="continent-box-content">
            <template v-for="(v, ind) in continent">
            <div class="continent" :key="ind" v-if="(v.continent_id === continentSelect || continentSelect === -1) && !v.shouldNotShow">
              <div class="left">{{continent_name.find((el) => el.continent_id == v.continent_id).name}}</div>
              <div class="right">
                <template v-for="(country, index) in v.country">
                  <div class="item-box" :key="index" v-if="country.holiday && country.holiday.length !== 0">
                    <div class="country-box">
                      <img :src="country.national_flag_img" alt="">
                      <span class="country-name">{{country.country}}</span>
                    </div>
                    <div class="time-box">
                      <span v-for="hol in country.holiday" :key="hol">{{formatDateWithConcat(hol)}}</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            </template>
          </div>
          <div class="no-data" v-if="noCountryShow">
            <img src="https://o.666visa.cn/static/ssqpeer/homepage/country-no-data-2x.png" alt="">
            <p>抱歉！暂无信息</p>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash';
import dateUtils from '../../../libs/date-util';
import Http from '../../../libs/http';

export default {
  name: 'all-embassy-holiday-pop',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      qrcodeUrl: '',
      dataArr: [],
      continentName: ['亚洲', '欧洲', '美洲', '大洋洲', '非洲'],
      continent_name: [],
      old_continent: [],
      countryHolidays: [],
      continent: [],
      allcontinent: [],
      continentSelect: -1,
      noCountryShow: false,
      noBackground: false, // 是否显示背景图
    };
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.getQrcode();
        this.getData().then(() => {
          this.continentSelectChange(this.continentSelect);
        });
      }
    },
  },
  created() {
  },
  methods: {

    // 关闭
    closePop() {
      this.$emit('input', false);
    },

    // 获取二维码
    getQrcode() {
      const postData = {
        page: 'subpackage/pages/embassy-holiday/embassy-holiday',
        size: 300,
        scene: 'f=peer',
      };

      Http.post('/sys/qrcode_get', postData).then((data) => {
        this.qrcodeUrl = `data:image/jpeg;base64,${data.qrcode}`;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 获取数据
    getData() {
      return Http.post('/sys/visa_continent_query')
        .then((data) => {
          this.old_continent = data.continent;

          // 构造可选的洲
          this.continent_name = [
            {
              name: '全部大洲',
              continent_id: -1,
            },
          ];
          data.continent.forEach((continent) => {
          // 可选的洲
            this.continent_name.push({
              name: this.continentName[continent.continent_id],
              continent_id: continent.continent_id,
            });
          });
        })
        .then(() => Http.post('/sys/visa_country_holiday_date_query', {}))
        .then((data) => {
          this.countryHolidays = data;
          this.putinCountryHoliday();
          this.$forceUpdate();
        })
        .catch(() => {});
    },

    // 将国家放假日期放进国家数组里
    putinCountryHoliday() {
      this.continent = this.old_continent;

      // 将对应国家的放假日期放进对应的国家数组
      this.continent.forEach((continent) => {

        // 遍历洲里面的国家
        continent.country.forEach((country) => {

          // 国家日历里面的国家id
          Object.keys(this.countryHolidays).forEach((country_id) => {

            // 若国家id相等，放入对应国家对象里面
            if (+country_id === country.visa_country_id) {

              // 过滤掉周末, 过滤60天之后日期
              country.holiday = this.countryHolidays[country_id].filter((date, index) => {

                const holidayTime = new Date(date).getTime();

                // 将当前日期设置为早上8点0分0秒0毫秒
                let now = new Date().setHours(8);
                now = new Date(now).setMinutes(0);
                now = new Date(now).setSeconds(0);
                now = new Date(now).setMilliseconds(0);

                // 设置需要显示的日期的条件
                const isNeedReturnDay = this.setNeedReturnDay(date, this.countryHolidays[country_id], index);
                return (
                  isNeedReturnDay &&
                  holidayTime - now <= 5184000000 &&
                  holidayTime >= now
                );
              });
              country.holiday = _.sortBy(country.holiday, date => new Date(date));
              country.holiday = this.concatDate(country.holiday);
            }
          });
        });
      });

      // 过滤掉没有日期的国家
      this.continent.forEach((continent) => {
        continent.shouldNotShow = continent.country.every(
          country => !country.holiday || country.holiday.length === 0,
        );
      });
    },

    // 选择大洲切换
    continentSelectChange(num) {
      this.continentSelect = num;
      this.noCountryShow = this.continent.some(
        val => val.continent_id === num && val.shouldNotShow,
      );
      this.$nextTick(() => {
        try {
          const continentBoxHeight = document.querySelector('.all-embassy-holiday-pop .continent-box .continent-box-content').clientHeight;
          if (continentBoxHeight > 225) {
            this.noBackground = true;
          } else {
            this.noBackground = false;
          }
        } catch (error) {
          //
        }
      });
    },

    formatDateWithWeek: dateUtils.formatDateWithWeek,
    formatDateWithConcat: dateUtils.formatDateWithConcat,
    concatDate: dateUtils.concatDate,
    setNeedReturnDay: dateUtils.setNeedReturnDay,
  },

};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";
/deep/ .all-embassy-holiday-pop{
  width: 680px;
  height: 560px;
  transform: translate(-50%,-50%);
  box-shadow: 0px 8px 12px 0px rgba(57,61,70,0.06);
  border-radius: 4px;
  margin: 0;
  .el-dialog__header{
    padding: 0;
  }
  .el-dialog__body{
    padding: 0;
  }
  .close-box {
    position: absolute;
    top: 0;
    right: -72px;
    border-radius: 1px;
    img {
      width: 52px;
      height: 52px;
    }
  }
  .QR-boxcode-box {
    position: absolute;
    bottom: 0;
    left: 100%;
    margin-left: 20px;
    padding: 12px;
    background: linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(255,255,255,1) 100%);
    box-shadow: 6px 0px 20px 0px rgba(47,51,61,0.08);
    border-radius: 4px;
    display: flex;
    flex-flow: column;
    align-items: center;
    img {
      width: 150px;
      height: 150px;
      margin-top: 12px;
    }
    div {
      color: #599FFF;
      font-size: 16rpx;
      font-weight: bold;
      margin: 8px 0;
    }
    span {
      color: #2F333D;
      font-size: 12px;
    }
  }
  .title-box {
    background: rgba(36,194,221,1);
    border-radius: 4px 4px 0px 0px;
    padding: 24px 0 44px 32px;
    color: #FFFFFF;
    font-size: 24px;
    font-weight: bold;
    span {
      font-size: 20px;
      color:rgba(255,255,255,0.4);
      margin-left: 8px;
    }
  }
  .content-box {
    padding: 38px 32px 32px 32px;
    position: relative;
    .select-box {
      position: absolute;
      top: -20px;
      left: 32px;
      width: 115px;
      height: 40px;
      background:rgba(255,255,255,1);
      box-shadow: 0px 12px 20px -10px rgba(0,159,182,0.3);
      border-radius: 2px;
      .el-input {
        height: 100%;
        .el-input__icon {
          color: #24C2DD!important;
          width: 28px;
          transform: translateY(-50%) rotateZ(180deg) scale(0.7);
          transform-origin: center center;
          &.is-reverse{
            transform: translateY(-50%) scale(0.7);
          }
        }
        .el-input__inner {
          height: 100%;
          color: #24C2DD;
          font-size: 14px;
          padding-left: 32px;
          padding-right: 28px;
        }
      }
      input {
        border: none;
      }
    }
    .select-icon {
      position: absolute;
      top: -11px;
      left: 42px;
      width: 20px;
      height: 20px;
    }
    .content {
      width: 100%;
      border: 1px solid rgba(233,238,242,1);
      background: url(https://o.666visa.cn/static/ssqpeer/homepage/country-background-default-2x.png) no-repeat center bottom / 616px 120px;
      &.no-background {
        background: none;
      }
      .title {
        height: 46px;
        background:rgba(243,246,249,1);
        display: flex;
        align-items: center;
        padding-left: 20px;
        color: #5F666E;
        font-size: 16px;
        line-height: 1;
        .title-continent {
          width: 80px;
        }
        .title-country {
          width: 155px;
        }
      }
      .continent-box {
        height: 351px;
        overflow-y: auto;
      }
      .continent {
        display: flex;
        &:nth-child(odd) {
          background-color: #ffffff;
        }
        &:nth-child(even) {
          background-color: #FAFBFC;
        }
        .left {
          color: #2F333D;
          font-size: 16px;
          font-weight: bold;
          padding: 20px 0 0 20px;
          width: 100px;
          flex-shrink: 0;
        }
        .right {
          flex: 1;
          .item-box {
            border-bottom: 1px solid #E9EEF2;
            padding: 14px 0 6px 0;
            display: flex;
            align-items: flex-start;
            .country-box {
              display: flex;
              align-items: center;
              width: 155px;
              padding: 2px 20px 2px 0;
              color: #2F333D;
              font-size: 16px;
              line-height: 1;
              img {
                width: 32px;
                height: 22px;
                margin-right: 8px;
                flex-shrink: 0;
                border-radius: 2px;
              }
              .country-name {
                display: inline-block;
                width: 0;
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .time-box {
              display: flex;
              width: 0px;
              flex: 1;
              flex-wrap: wrap;
              span {
                margin-right: 8px;
                height: 26px;
                background-color: rgba(36,194,221,0.08);
                border-radius: 2px;
                line-height: 26px;
                font-size: 14px;
                padding: 0 10px;
                margin-bottom: 8px;
              }
            }
          }
        }
        &:last-child {
          .right {
            .item-box {
              &:last-child {
                border-bottom: none;
              }
            }
          }
        }
      }
      .no-data {
        display: flex;
        flex-flow: column;
        align-items: center;
        img {
          width: 140px;
          height: 90px;
          margin-top: 40px;
        }
        p {
          color: #91999F;
          font-size: 14px;
          line-height: 1;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/all-embassy-holiday-pop.vue